import { useSearchParams } from "react-router";
import { useLocale } from "../locale/locale-context.tsx";
import { AuthShell } from "./login.tsx";

export function VerifyEmailPage() {
  const { t } = useLocale();
  const [params] = useSearchParams();
  const email = params.get("email") ?? "";

  return (
    <AuthShell heading={t("auth.verify_email")}>
      <p className="text-sm text-[var(--brand-muted)]">{t("auth.verify_email_sent", { email })}</p>
    </AuthShell>
  );
}
